import type { Course } from "@brookbush/types";

import Image from "next/image";

import replaceTemplateStrings from "~/utils/replaceTemplateStrings";

const CourseAccreditations = ({ course }: { course: Course }) => {
	const { accreditations, creditApprovalDetails, credits } = course;

	const aota = accreditations.find((acc) => acc.slug === "aota");
	const otherAccreditations = accreditations.filter(
		(acc) => acc.slug !== "aota",
	);

	return (
		<div className="mx-auto flex flex-col items-center gap-4 sm:gap-6">
			<h2 className="font-semibold text-2xl sm:text-2xl">Accreditations</h2>
			{aota && (
				<div className="w-full rounded-xl border border-slate-100 bg-slate-100 p-4 hover:ring-slate-200 dark:bg-white dark:hover:ring-slate-600">
					<div className="flex flex-row items-center gap-5">
						<div className="relative aspect-video h-24 w-full sm:h-36">
							<Image
								fill
								src={aota.thumbnail.url}
								alt={aota.title}
								className="object-contain"
							/>
						</div>
						<p className="text-left text-sm dark:text-gray-800">
							{replaceTemplateStrings(aota.certificateText || "", {
								...creditApprovalDetails,
								credits: credits.toString(),
							} as unknown as Record<string, string>)}
						</p>
					</div>
				</div>
			)}
			<div className="mx-auto grid grid-cols-2 gap-4 text-xl sm:grid-cols-3 sm:gap-6 lg:grid-cols-4">
				{otherAccreditations.map((accreditation) => (
					<div
						key={accreditation.slug}
						className="group w-full rounded-xl border border-slate-100 bg-slate-100 p-2 transition-all sm:p-3 dark:bg-white dark:hover:ring-slate-600"
					>
						<div className="relative mx-auto aspect-video h-24 w-full sm:h-36">
							<Image
								fill
								src={accreditation.thumbnail.url}
								alt={accreditation.title}
								className="object-contain transition-all duration-300"
							/>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default CourseAccreditations;
